import PropTypes from "prop-types"
import React from "react"
import { Box } from "@material-ui/core"

import useStyles from "./styles"
import StatusChecker from "./StatusChecker/index"
import RoleIdentityComponent from "../../../Common/RoleIdentityComponent/index"

const CrewStatusTableRow = ({ role = {} }) => {
  const classes = useStyles()

  return (
    <Box className={classes.crewRow}>
      <Box className={classes.crewNameWrapper}>
        <RoleIdentityComponent role={role} />
      </Box>
      <Box className={classes.statusDotWrapper}>
        <StatusChecker role={role} />
      </Box>
    </Box>
  )
}

CrewStatusTableRow.propTypes = {
  role: PropTypes.object,
}

export default CrewStatusTableRow
